"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var icons_1 = __importDefault(require("../../../../assets/icons"));
var theme_1 = __importDefault(require("../../../../styles/theme"));
var objectUtilities_1 = require("../../../../util/objectUtilities");
var Icon_1 = require("../../../atoms/Icon/Icon");
var Typography_1 = require("../../../atoms/Typography/Typography");
var Table_static_1 = require("../Table.static");
var TableRow_style_1 = __importDefault(require("./TableRow.style"));
var TableRow = function (_a) {
    var className = _a.className, _b = _a.isHeadingRow, isHeadingRow = _b === void 0 ? false : _b, cells = _a.cells, columnGap = _a.columnGap, state = _a.state, onClick = _a.onClick, compact = _a.compact, alternatingColors = _a.alternatingColors;
    var classes = (0, TableRow_style_1.default)({ columnGap: columnGap });
    var Component = isHeadingRow ? 'th' : 'td';
    return ((0, jsx_runtime_1.jsx)("tr", __assign({ className: (0, classnames_1.default)(className, classes.root, compact && classes.rootCompact, alternatingColors && classes.rootAlternateColor, classes.spacing, state === Table_static_1.RowState.Disabled && classes.disabledRow, state === Table_static_1.RowState.Highlighted && classes.highlightedRow, state === Table_static_1.RowState.Important && classes.importantRow), onClick: onClick }, { children: cells.map(function (cell, index) {
            var style = cell.style, colSpan = cell.colSpan, onSortClick = cell.onSortClick, itemClassName = cell.className, align = cell.align;
            return ((0, jsx_runtime_1.jsx)(Component, __assign({ style: style, colSpan: colSpan, className: (0, classnames_1.default)(itemClassName) }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: (0, classnames_1.default)(classes.cell, isHeadingRow && !!onSortClick && classes.pointer, align === 'left' && classes.justifyLeft, align === 'right' && classes.justifyRight), onClick: isHeadingRow ? onSortClick : undefined }, { children: renderCellContent(cell, index) })) }), index));
        }) })));
    function renderCellContent(_a, index) {
        var content = _a.content, align = _a.align, sortOrder = _a.sortOrder, onSortClick = _a.onSortClick;
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [typeof content === 'string' ? ((0, jsx_runtime_1.jsx)(Typography_1.Typography, __assign({ noWrap: isHeadingRow ? true : undefined, variant: isHeadingRow ? 'headline3' : 'body', textAlign: align }, { children: content }), index)) : (content), isHeadingRow && !!onSortClick && ((0, jsx_runtime_1.jsx)(Icon_1.Icon, { iconPath: getSortIcon(sortOrder), className: (0, classnames_1.default)(classes.sortIcon, sortOrder === Table_static_1.SortOrder.None && classes.sortIconNone), color: theme_1.default.textColors.primary }))] }));
    }
    function getSortIcon(sortOrder) {
        switch (sortOrder) {
            case Table_static_1.SortOrder.None:
                return icons_1.default.unSorted;
            case Table_static_1.SortOrder.ASC:
                return icons_1.default.sortAsc;
            case Table_static_1.SortOrder.DESC:
                return icons_1.default.sortDesc;
            default:
                return (0, objectUtilities_1.exhaustivenessCheck)(sortOrder);
        }
    }
};
exports.default = TableRow;
